import { render, staticRenderFns } from "./ColorModuleTitle.vue?vue&type=template&id=442197c2&scoped=true"
import script from "./ColorModuleTitle.vue?vue&type=script&lang=ts"
export * from "./ColorModuleTitle.vue?vue&type=script&lang=ts"
import style0 from "./ColorModuleTitle.vue?vue&type=style&index=0&id=442197c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442197c2",
  null
  
)

export default component.exports